// --------------------------------------------------------------
// Created On: 2023-02-16
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useRef } from "react";
import styles from "./SearchBar.module.scss";

// Generic search bar.
export default function SearchBar(props: Props): Component {
  const searchInput = useRef(null);

  // Check if the user pressed enter while focused on the search bar.
  function checkPressEnter(e: React.KeyboardEvent): void {
    if (e.key === "Enter" && document.activeElement === searchInput.current) {
      props.onSubmit(props.searchQuery);
    }
  }

  return (
    <div
      className={`${styles.body} ${props.location === "NAVIGATION_DRAWER" ? styles.navigationDrawer : ""} ${
        props.location === "NAVBAR" ? styles.navbar : ""
      } search nav-item`}
      onKeyDown={(e) => checkPressEnter(e)}
    >
      {/* Collapsed icon-only button shown when there is no room for the full search bar. */}
      {props.location === "NAVBAR" && (
        <button
          type="button"
          className={`${styles.iconButton} btn btn-primary`}
          onClick={() => props.onSubmit(props.searchQuery)}
        >
          <i className="fa fa-fw fa-search" />
        </button>
      )}

      {/* Full search bar with text input. */}
      <div className={styles.fullBar} onSubmit={() => props.onSubmit(props.searchQuery)}>
        <input
          data-test="search-bar-input"
          type="search"
          className={`${styles.input} form-control`}
          placeholder={props.prompt}
          value={props.searchQuery}
          ref={searchInput}
          onChange={(e) => props.onChange(e.target.value)}
        />
        <button
          data-test="search-bar-button"
          type="button"
          className={`${styles.button} btn btn-primary`}
          onClick={() => props.onSubmit(props.searchQuery)}
        >
          <i className="fa fa-fw fa-search" />
        </button>
      </div>
    </div>
  );
}

interface Props {
  prompt: string;
  location?: "NAVBAR" | "NAVIGATION_DRAWER";
  searchQuery: string;
  onChange: (searchQuery: string) => void;
  onSubmit: (searchQuery: string) => void;
}
